import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl, springBaseUrl } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/Footer";
import {
  saveCartEarlyCheckin,
  saveEarlyCheckinnSlot,
} from "../redux/slice/slice";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MainSkeleton from "../skeletons/MainSkeleton";
import CheckinSkeleton from "../skeletons/CheckinSkeleton";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { TimePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

dayjs.extend(advancedFormat);

const ModifyBooking = () => {
  const navigate = useNavigate();
  const hotelId = useSelector((state) => state?.HotelId);
  const HomepageData = useSelector((state) => state?.HomepageData);
  const SummaryData = useSelector((state) => state?.SummaryData);
  const currencySymbol = useSelector((state) => state?.Currency);
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);
  const [checkInDate, setCheckInDate] = useState(dayjs(new Date()));
  const [checkInTime, setCheckInTime] = useState(0);
  const [checkOutDate, setCheckOutDate] = useState(dayjs(new Date()));
  const [checkOutTime, setCheckOutTime] = useState(0);
  const [checkinAndCheckoutSlots, setCheckinAndCheckoutSlots] = useState({});
  const [quickEditPrice, setQuickEditPrice] = useState({});
  const [modifyLoader, setModifyLoader] = useState(false);
  const [priceLoading, setPriceLoading] = useState(false);
  const [isValidUpgrade, setIsValidUpgrade] = useState(true);

  useEffect(() => {
    setCheckInDate(
      dayjs(HomepageData?.booking?.bookingCin, "DD-MM-YYYY HH:mm:ss")
    );
    setCheckOutDate(
      dayjs(HomepageData?.booking?.bookingCout, "DD-MM-YYYY HH:mm:ss")
    );
    setCheckInTime(
      +HomepageData?.booking?.bookingCin?.split(" ")?.[1]?.split(":")?.[0]
    );
    setCheckOutTime(
      +HomepageData?.booking?.bookingCout?.split(" ")?.[1]?.split(":")?.[0]
    );
  }, [HomepageData]);

  useEffect(() => {
    setLoader(true);
    axios
      .get(
        `${springBaseUrl}/core/api/v1/reservation/getCheckinAndCheckoutSlotsNoAuth?checkin=${moment(
          new Date()
        ).format("DD-MM-YYYY")}+00:00:00&checkout=${moment(new Date()).format(
          "DD-MM-YYYY"
        )}+00:00:00&hotel_id=${hotelId}&hotelId=${hotelId}`
      )
      .then((res) => {
        setLoader(false);
        setCheckinAndCheckoutSlots(res?.data);
      })
      .catch(() => {
        setLoader(false);
      });
  }, []);
  useEffect(() => {
    setIsValidUpgrade(true);
    const payload = {
      hotelId: hotelId,
      checkin: `${checkInDate.format("DD-MM-YYYY")} ${checkInTime}:00:00`,
      checkout: `${checkOutDate.format("DD-MM-YYYY")} ${checkOutTime}:00:00`,
      newRate: null,
      newRateType: "TOTAL_PRETAX",
      bookingId: HomepageData?.booking?.bookingId,
    };
    setPriceLoading(true);
    axios
      .post(
        `${springBaseUrl}/core/api/v1/reservation/getQuickEditPricePayload-noauth?hotel_id=${hotelId}&hotelId=${hotelId}`,
        payload
      )
      .then((res) => {
        setPriceLoading(false);
        setQuickEditPrice(res?.data);
      })
      .catch(() => {
        setPriceLoading(false);
      });
  }, [checkInDate, checkOutDate, checkInTime, checkOutTime]);

  const handleModifyBooking = () => {
    const checkIn = moment(
      HomepageData?.booking?.bookingCin,
      "DD-MM-YYYY HH:mm:ss"
    );
    const checkOut = moment(
      HomepageData?.booking?.bookingCout,
      "DD-MM-YYYY HH:mm:ss"
    );
    const existingBookingNights = Math.ceil(
      checkOut.diff(checkIn, "days", true)
    );
    if (
      SummaryData?.payment_info?.total_room_amount?.toFixed(2) >
        quickEditPrice?.priceAfterTax?.toFixed(2) ||
      existingBookingNights > quickEditPrice?.numNights
    ) {
      setIsValidUpgrade(false);
      return;
    }

    const payload = {
      bookingId: HomepageData?.booking?.bookingId,
      checkin: `${checkInDate.format("DD-MM-YYYY")} ${checkInTime}:00:00`,
      checkout: `${checkOutDate.format("DD-MM-YYYY")} ${checkOutTime}:00:00`,
      editCost: quickEditPrice?.priceAfterTax,
      fromSelfServiceLink: true,
    };
    setModifyLoader(true);
    axios
      .put(
        `${springBaseUrl}/core/api/v1/reservation/edit-booking-noAuth?hotel_id=${hotelId}&hotelId=${hotelId}`,
        payload
      )
      .then((res) => {
        setModifyLoader(false);
        navigate("/modify-status", {
          state: { response: payload },
        });
      })
      .catch(() => {
        setModifyLoader(false);
      });
  };

  const checkinSelection = (newValue) => {
    setCheckInDate(newValue);
    // Convert check-in date to a Date object
    const checkinDate = new Date(newValue);

    // Convert check-out date to a Date object
    const checkoutDate = new Date(checkOutDate);

    // If check-out date is before or same as check-in date, set it to the next day
    if (!checkOutDate || checkoutDate <= checkinDate) {
      const nextDay = new Date(checkinDate);
      nextDay.setDate(nextDay.getDate() + 1);
      setCheckOutDate(dayjs(nextDay));
    }
  };

  return (
    <>
      {loader ? (
        <CheckinSkeleton />
      ) : (
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <IconButton
              sx={{ backgroundColor: "#3D3D3D4D" }}
              onClick={() => {
                window.history.back();
              }}
            >
              <KeyboardArrowLeftIcon
                sx={{ color: "#FFFFFF", fontSize: 24, strokeWidth: 2 }}
              />
            </IconButton>
            <Typography
              sx={{ fontSize: 24, fontWeight: 900 }}
              color="text.gray"
            >
              Edit dates
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              mt: 5,
            }}
          >
            {/* checkin */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Check-in Date"
                        value={checkInDate}
                        onChange={(newValue) => checkinSelection(newValue)}
                        format="Do MMM, YYYY"
                        shouldDisableDate={(date) =>
                          date < new Date().setHours(0, 0, 0, 0)
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#3D3D3D4D",
                            borderRadius: 2,
                            "& fieldset": {
                              border: "none",
                              borderRadius: 2,
                            },
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#CCCCCC",
                          },
                        }}
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiPickersCalendarHeader-label": {
                                color: "#000000",
                              },
                              "& .MuiPickersArrowSwitcher-button": {
                                color: "#000000",
                              },
                              "& .MuiPickersDay-root": {
                                color: "#000000",
                              },
                              "& .MuiTypography-root": {
                                color: "#000000",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Box>
                <Box>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Check-out Date"
                        value={checkOutDate}
                        onChange={(newValue) => setCheckOutDate(newValue)}
                        format="Do MMM, YYYY"
                        shouldDisableDate={(date) =>
                          date < new Date(checkInDate)
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#3D3D3D4D",
                            borderRadius: 2,
                            "& fieldset": {
                              border: "none",
                              borderRadius: 2,
                            },
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#CCCCCC",
                          },
                        }}
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiPickersCalendarHeader-label": {
                                color: "#000000",
                              },
                              "& .MuiPickersArrowSwitcher-button": {
                                color: "#000000",
                              },
                              "& .MuiPickersDay-root": {
                                color: "#000000",
                              },
                              "& .MuiTypography-root": {
                                color: "#000000",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Box>
                {/* <Box>
                {checkinAndCheckoutSlots?.checkinSlots && (
                  <FormControl
                    fullWidth
                    sx={{
                      backgroundColor: "#3D3D3D4D",
                      borderRadius: 2,
                      width: 150,
                    }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Check - in time
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Check - in time"
                      value={checkInTime}
                      onChange={(e) => setCheckInTime(e?.target?.value)}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: 2,
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#CCCCCC",
                        },
                      }}
                    >
                      {checkinAndCheckoutSlots?.checkinSlots.map((time) => (
                        <MenuItem value={time}>
                          {dayjs(`${time}:00`, "HH:mm").format("hh:mm A")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box> */}
                {/* <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Check - in time"
                    value={checkInTime}
                    onChange={(newValue) => setCheckInTime(newValue)}
                    sx={{
                      width: 150,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#3D3D3D4D",
                        borderRadius: 2,
                        "& fieldset": {
                          borderRadius: 2,
                        },
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#CCCCCC",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box> */}
              </Box>
            </Box>
            {/* checkout */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              {/* <Box>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Check-out Date"
                      value={checkOutDate}
                      onChange={(newValue) => setCheckOutDate(newValue)}
                      format="Do MMM, YYYY"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#3D3D3D4D",
                          borderRadius: 2,
                          "& fieldset": {
                            border: "none",
                            borderRadius: 2,
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#CCCCCC",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Box> */}
              {/* <Box>
                {checkinAndCheckoutSlots?.checkoutSlots && (
                  <FormControl
                    fullWidth
                    sx={{
                      backgroundColor: "#3D3D3D4D",
                      borderRadius: 2,
                      width: 150,
                    }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Check - out time
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Check - out time"
                      value={checkOutTime}
                      onChange={(e) => setCheckOutTime(e?.target?.value)}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: 2,
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#CCCCCC",
                        },
                      }}
                    >
                      {checkinAndCheckoutSlots?.checkoutSlots.map((time) => (
                        <MenuItem value={time}>
                          {dayjs(`${time}:00`, "HH:mm").format("hh:mm A")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box> */}
              {/* <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Check - out time"
                    value={checkOutTime}
                    onChange={(newValue) => setCheckOutTime(newValue)}
                    sx={{
                      width: 150,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#3D3D3D4D",
                        borderRadius: 2,
                        "& fieldset": {
                          borderRadius: 2,
                        },
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#CCCCCC",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box> */}
            </Box>
            {!isValidUpgrade && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Alert
                  severity="error"
                  sx={{
                    maxWidth: 468,
                    borderRadius: 2,
                    backgroundColor: "rgba(255, 76, 76, 0.15)", // Soft red bg
                    color: "#ff6b6b", // Slightly stronger red text
                    borderLeft: "4px solid #ff4c4c", // Accent border
                    fontWeight: "bold",
                    boxShadow: "0px 2px 10px rgba(255, 76, 76, 0.2)",
                  }}
                >
                  Modification not allowed: The updated booking must include at
                  least the same number of nights as the existing booking.
                  Additionally, the total amount must be greater than or equal
                  to the current booking amount to proceed.
                </Alert>
              </Box>
            )}

            {/* Footer with Proceed Button */}
            <Footer>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  maxWidth: 500,
                  gap: 2,
                  border: "1px solid #3D3D3D4D",
                  p: 2,
                  borderRadius: 30,
                }}
              >
                <Card
                  sx={{
                    backgroundColor: "#3D3D3D4D",
                    borderRadius: "26px",
                    paddingX: "20px",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{ fontSize: 16, fontWeight: 400 }}
                    color="text.secondary"
                  >
                    Amount
                  </Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
                    {currencySymbol}{" "}
                    {quickEditPrice?.priceAfterTax
                      ? quickEditPrice?.priceAfterTax?.toFixed(2)
                      : 0}
                  </Typography>
                </Card>
                <Button
                  sx={{ height: 51 }}
                  fullWidth
                  variant="light-button"
                  onClick={handleModifyBooking}
                  disabled={
                    modifyLoader ||
                    priceLoading ||
                    (dayjs(
                      HomepageData?.booking?.bookingCin,
                      "DD-MM-YYYY HH:mm:ss"
                    ).isSame(checkInDate, "day") &&
                      dayjs(
                        HomepageData?.booking?.bookingCout,
                        "DD-MM-YYYY HH:mm:ss"
                      ).isSame(checkOutDate, "day"))
                  }
                >
                  Proceed{" "}
                  {modifyLoader && (
                    <CircularProgress size={20} sx={{ color: "#FFF" }} />
                  )}
                </Button>
              </Box>
            </Footer>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ModifyBooking;
